import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enResources from "./locales/en.json";
import slResources from "./locales/sl.json";
import deResources from "./locales/de.json";
import itResources from "./locales/it.json";
import ukResources from "./locales/uk.json";
import frResources from "./locales/fr.json";
import { getCachedUserLocation } from "./utils/userLocation";

const resources = {
    en: {translation: enResources},
    sl: {translation: slResources},
    de: {translation: deResources},
    it: {translation: itResources},
    uk: { translation: ukResources },
    fr: { translation: frResources },
};

const countryToLanguageMap = {
    si: "sl", // Slovenia
    de: "de", // Germany
    at: "de", // Austria
    ch: "de", // Switzerland
    it: "it", // Italy
    us: "en", // United States
    gb: "en", // United Kingdom
    ca: "en", // Canada
    au: "en", // Australia
    fr: "fr", // France
    ua: "uk", // Ukraine
};

const getDefaultLanguage = async () => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) return savedLanguage;

    const userLocation = await getCachedUserLocation();

    if (userLocation && userLocation.countryCode) {
        const countryCode = userLocation.countryCode.toLowerCase();
        const languageCode = countryToLanguageMap[countryCode] || "en";
        return languageCode;
    }
    return "en";
};

(async () => {
    const defaultLanguage = await getDefaultLanguage();

    i18n
        .use(initReactI18next)
        .init({
            resources,
            lng: defaultLanguage,
            supportedLngs: ["en", "sl", "de", "it", "uk", "fr"],
            interpolation: {
                escapeValue: false,
            },
        });

    i18n.on('languageChanged', (lng) => {
        localStorage.setItem('language', lng);
    });
})();

export default i18n;